<template>
  <v-dialog
    :value="value"
    max-width="620"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="pa-4 pa-md-5">
        <div>
          <div class="text-h6 font-weight-bold text-typo">
            {{ $t("Atalhos_de_teclado") }}
          </div>
          <div class="text-body-2 text--secondary font-weight-regular">
            {{
              $t(
                "Atalhos_contextuais_para_trabalhar_sem_tirar_as_maos_do_teclado"
              )
            }}
          </div>
        </div>
        <v-spacer />
        <v-btn
          ref="closeButton"
          icon
          :aria-label="$t('Fechar')"
          @click="$emit('input', false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4 pa-md-5">
        <div
          v-for="shortcut in shortcuts"
          :key="shortcut.teclas + shortcut.descricao"
          class="crud-shortcut-row"
        >
          <div class="crud-shortcut-keys">
            <kbd v-for="keyName in splitKeys(shortcut.teclas)" :key="keyName">
              {{ keyName }}
            </kbd>
          </div>
          <span class="text-body-2">{{ $t(shortcut.descricao) }}</span>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <span class="text-caption text--secondary">
          {{ $t(footerKey) }}
        </span>
        <v-spacer />
        <v-btn
          color="primary"
          text
          class="text-none"
          @click="$emit('input', false)"
        >
          {{ $t("Entendi") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  consumeKeyboardEvent,
  getTopActiveDialog,
  trapTabWithin,
} from "@/utils/crudKeyboard";

export default {
  name: "CrudKeyboardShortcutsDialog",
  props: {
    value: { type: Boolean, default: false },
    shortcuts: { type: Array, default: () => [] },
    footerKey: {
      type: String,
      default: "O_Tab_percorre_os_controles_e_fica_contido_no_modal_ativo",
    },
  },
  watch: {
    value(open) {
      if (!open) return;
      this.$nextTick(() => {
        const button = this.$refs.closeButton;
        const element = button?.$el || button;
        element?.focus?.();
      });
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleDialogKeydown, true);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleDialogKeydown, true);
  },
  methods: {
    splitKeys(value) {
      return String(value || "")
        .split("+")
        .map((key) => key.trim())
        .filter(Boolean);
    },
    handleDialogKeydown(event) {
      if (!this.value) return;
      const dialog = getTopActiveDialog(this.$el?.ownerDocument);
      if (!dialog) return;

      if (event.key === "Tab") {
        trapTabWithin(dialog, event);
        return;
      }
      if (event.key === "Escape" || event.key === "Esc") {
        consumeKeyboardEvent(event, true);
        this.$emit("input", false);
      }
    },
  },
};
</script>

<style scoped>
.crud-shortcut-row {
  align-items: center;
  border-bottom: 1px solid #edf0f4;
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(150px, 0.8fr) 1.7fr;
  padding: 12px 0;
}

.crud-shortcut-row:last-child {
  border-bottom: 0;
}

.crud-shortcut-keys {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.crud-shortcut-keys kbd {
  background: #f8fafc;
  border: 1px solid #d8deea;
  border-bottom-width: 2px;
  border-radius: 5px;
  color: #344054;
  font-family: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.35;
  padding: 3px 7px;
}

@media (max-width: 600px) {
  .crud-shortcut-row {
    grid-template-columns: 1fr;
    gap: 7px;
  }
}
</style>
